import * as React from 'react';
import { Img } from 'react-image'
import { CircularProgress } from '@mui/material';
import { ApiContext } from '../components/ApiProvider';
import { images } from '../utils';

export const TourOperatorLogo = ({ operator = null, settings = null, size = 30 }) => {
    const context = React.useContext(ApiContext);
    
    const actualOperator = operator || context?.tourOperator;
    const actualSettings = settings || context?.settings;
    
    if (!actualOperator?.name || !actualOperator?.logo) {
        return <CircularProgress size={size} />;
    }
    
    let logoURL;
    if (typeof actualOperator.logo === 'string') {
        logoURL = actualSettings?.images?.base 
            ? images.url(actualSettings.images.base, actualOperator.logo, `x${size}`)
            : actualOperator.logo;
    } else if (actualOperator.logo?.url) {
        logoURL = actualOperator.logo.url;
    } else if (actualOperator.logo?.p && actualOperator.logo?.s) {
        if (actualSettings?.images?.base) {
            logoURL = images.url(actualSettings.images.base, actualOperator.logo, `x${size}`);
        } else {
            return <CircularProgress size={size} />;
        }
    } else {
        return <CircularProgress size={size} />;
    }
    
    return (
        <React.Suspense fallback={<CircularProgress size={size} />}>
            <Img 
                src={logoURL} 
                alt={actualOperator.name}
                style={{ 
                    width: `${size}px`, 
                    height: `${size}px`, 
                    objectFit: 'contain',
                    mixBlendMode: 'multiply'
                }}
            />
        </React.Suspense>
    );
}

export default TourOperatorLogo;
